import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import PageContentSkeleton from "@/components/shared/PageContentSkeleton";

/**
 * Full-screen app-shell skeleton (sidebar + header + content). Shown while the
 * dashboard LAYOUT chunk itself is loading (top-level Suspense). Deliberately
 * mirrors the pre-JS boot skeleton in index.html so the boot→React handoff has
 * no visual jump. Once the layout is mounted, page-to-page navigation uses the
 * lighter PageContentSkeleton (sidebar/header stay real).
 */
export default function AppShellSkeleton() {
  return (
    <div className="flex min-h-screen bg-canvas" role="status" aria-busy="true" aria-label="Yuklanmoqda">
      {/* Sidebar */}
      <aside className="hidden w-[248px] shrink-0 border-r border-hairline bg-panel p-4 md:block">
        <Skeleton className="mb-7 h-8 w-28" />
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className={cn("mb-2.5 h-9", i % 2 ? "w-2/3" : "w-full")} />
        ))}
      </aside>

      {/* Main column */}
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-[60px] items-center justify-between border-b border-hairline bg-panel px-6">
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-9 w-9 rounded-full" />
        </header>
        <div className="flex-1 p-6">
          <PageContentSkeleton />
        </div>
      </div>
      <span className="sr-only">Yuklanmoqda…</span>
    </div>
  );
}
